module.exports = __webpack_public_path__ + "static/media/computer.29aa9e8d.svg";